/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {SPS_INFO_ACCESS_TOKEN, getCookieByName} from "./cookieUtils";
import {getTokenFromLocalStorage} from "./tokenUtils";

/**
 * Checks to see if the users token is not set in the Redux store. If not:
 * 1. Check to see if a token can be retrieved from Cookies
 * 2. Check if there's a token in the .env.local file (only used in non image build)
 *
 * @return - returns a valid TokenState, even if nothing is set.
 *
 */

export const token = {
  accessToken: ''
}
export default function buildTokensFromSources() {

  // If we have the tokens in the cookies, use those
  const accessToken = getCookieByName(SPS_INFO_ACCESS_TOKEN);

  if (accessToken) {
    token.accessToken = accessToken;

  } else if (process.env.REACT_APP_ACCESS_TOKEN) {
    // Developers can set a tokens in their .env files
    token.accessToken = process.env.REACT_APP_ACCESS_TOKEN;

  }

  return token;
}